module.exports = __webpack_public_path__ + "img/psm_logo-inverse.b5c90867.png";